<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="usuarios"
      :server-items-length="totalUsers"
      :loading="loading"
      :page="page"
      :page-count="numberOfPages"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <UserFilter :options="options" @resource="handleFilterResource" />
          <v-btn class="rounded-lg ml-2" elevation="1" color="#2a6334" @click="dialog = true, resource = {}">
            <v-icon style="color: white">mdi-plus</v-icon>
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.cpf`]="{ item }">
        <span>{{ formatCpf(item.cpf) }}</span>
      </template>

      <template v-slot:[`item.profile`]="{ item }">
        <span>{{ setProfiles(item) }}</span>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          :color="item.deleted_at ? 'red lighten-1' : 'green lighten-3'"
          :text-color="item.deleted_at ? 'white' : 'green darken-3'"
        >
          {{ item.deleted_at ? "Inativo" : "Ativo" }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="dialog = true, resource = item" @openLinkModal="vinculoDialog = true, resource = item">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="users"
          />
        </Menu>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <UsuarioForm :openDialog="dialog" :resource="resource" @closeDialog="dialog = false, loadGridData()" />
    </Modal>

    <Modal v-model="vinculoDialog">
      <VinculoForm :resource="resource" @closeDialog="vinculoDialog = false, loadGridData()" />
    </Modal>
  </div>
</template>

<script>
import { getUsers } from "@/service/basic-registrations/UserService";
import UsuarioForm from "./User.vue";
import VinculoForm from "./Link.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import UserFilter from "./Filter.vue";
import CrudGrid from "../widgets/Grid.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import FormFieldsService from '@/service/FormFieldsService';
import Formatters from "@/utils/Formatters";

export default {
  components: {
    Menu,
    ChangeStatus,
    UsuarioForm,
    VinculoForm,
    UserFilter,
    CrudGrid,
    Modal,
  },

  data() {
    return {
      dialog: false,
      vinculoDialog: false,
      search: {
        name: "",
        email: "",
        hospital: null,
        profile: null,
        cpf: "",
      },
      headers: [
        { text: "Usuário", align: "start", value: "name" },
        { text: "CPF", align: "start", value: "cpf" },
        { text: "E-mail", align: "start", value: "email" },
        { text: "Unidade Hospitalar", align: "start", value: "unity.hospital" },
        { text: "Perfil", align: "start", value: "profile" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
      sortBy: "name",
      usuarios: [],
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UsuarioForm",
        },
        {
          name: "Adicionar Vínculo",
          type: "linkModal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "VinculoForm",
        },
        {
          name: "Visualizar Vínculos",
          type: "page",
          route: "/vinculos",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "ListVinculos",
        },
      ],
    };
  },

  computed: {
    setProfiles() {
      return item => item.profile ? item.profile.name : 'PERFIL INATIVADO';
    },
  },

  async created() {
    this.changeActionsData(this.actions);
    await FormFieldsService.getUnities();
    await FormFieldsService.getProfiles();
  },

  watch: {
    options: {
      handler() {
        this.loadGridData();
      },
      deep: true,
    },

    dialog(val) {
      if (!val) this.resource = {};
    },
  },

  methods: {
    ...mapActions(["changeActionsData"]),

    handleFilterResource({ result, search }) {
      this.search = search;
      this.usuarios = result.data;
      this.totalUsers = result.total;
      this.numberOfPages = result.last_page;
      this.loading = false;
    },

    loadGridData() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;

      sessionStorage.setItem('userSearchFilter', JSON.stringify(this.search));
      sessionStorage.setItem('userTableOptions', JSON.stringify({ page, itemsPerPage }));

      getUsers({
        name: this.search.name,
        hospital: this.search.hospital,
        email: this.search.email,
        profile: this.search.profile,
        cpf: Formatters.removeNonNumeric(this.search.cpf),
        page,
        per_page: itemsPerPage,
      }).then((result) => {
        this.loading = false;
        this.usuarios = result.data;
        this.totalUsers = result.total;
        this.numberOfPages = result.last_page;
      });
    },

    formatCpf(cpf) {
     return Formatters.formatCpf(cpf);
    },
  },

  mounted() {
    const savedSearch = sessionStorage.getItem('userSearchFilter');
    const savedOptions = sessionStorage.getItem('userTableOptions');

    if (savedSearch) this.search = JSON.parse(savedSearch);

    if (savedOptions) {
      const options = JSON.parse(savedOptions);
      this.options.page = options.page || 1;
      this.options.itemsPerPage = options.itemsPerPage || 10;
    }

    this.loadGridData();
  },
};
</script>

<style scoped>
.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}
</style>
